import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import MetaTags from "react-meta-tags";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const CredentialSystem = () => {
  const [token, setToken] = useState("");

  useEffect(() => {
    // Get token from localStorage when component mounts
    const userToken = localStorage.getItem("token");
    if (userToken) {
      setToken(userToken);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Credential System | Lavni</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Credential System" breadcrumbItem="Credential System" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="credential-system-iframe-container" style={{ height: "80vh" }}>
                    {token && (
                      <iframe
                        src={`https://credentil-system.mylavni.com/dashboard?token=${token}`}
                        title="Credential System"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                      />
                    )}
                    {!token && (
                      <div className="text-center p-5">
                        <h4>Loading credential system...</h4>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CredentialSystem;
